import { Navigate, Route, Routes } from "react-router"
import { getDealerAppRoute } from "src/common/routes"
import { NewsEditorContainer } from "../newsEditor/NewsEditorContainer"
import { NewsListContainer } from "../newsList/NewsListContainer"
import { useHasNewsAccess } from "../newsList/hooks/useHasNewsAccess/useHasNewsAccess"
import { useHasNewsManagerAccess } from "../newsList/hooks/useHasNewsManagerAccess/useHasNewsManagerAccess"
import { newsListPath } from "../newsList/newsListPath"
import { DealershipListScreen } from "./DealershipListScreen"

export const DealershipListRoutes = () => {
	const hasNewsAccess = useHasNewsAccess()
	const hasNewsManagerAccess = useHasNewsManagerAccess()

	return (
		<Routes>
			{hasNewsAccess && (
				<Route path={newsListPath}>
					<Route index element={<NewsListContainer />} />
					<Route
						path="new"
						element={
							hasNewsManagerAccess ? <NewsEditorContainer /> : <Navigate to={newsListPath} replace />
						}
					/>
					<Route path=":newsItemId" element={<NewsEditorContainer />} />
				</Route>
			)}
			<Route
				path="*"
				element={<DealershipListScreen getDealerAppUrl={getDealerAppRoute} data-testid="dealership-list" />}
			/>
		</Routes>
	)
}
